import React, { useState, useEffect } from "react";
import DashBoardLayerTen from "../components/DashBoardLayerTen";
import MasterLayout from "../masterLayout/MasterLayout";
import WelcomeModal from "../components/onboarding/WelcomeModal";

const HomePageTen = () => {
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);

  useEffect(() => {
    // Verificar se é a primeira vez que o usuário acessa
    const hasSeenWelcome = localStorage.getItem('hasSeenWelcomeModal');
    
    if (!hasSeenWelcome) {
      // Aguardar 1 segundo antes de mostrar o modal para melhor UX
      setTimeout(() => {
        setShowWelcomeModal(true);
      }, 1000);
    }
  }, []);

  const handleCloseWelcome = () => {
    // Marcar como visto para não aparecer novamente
    localStorage.setItem('hasSeenWelcomeModal', 'true');
    setShowWelcomeModal(false);
  };

  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* DashBoardLayerTen */}
        <DashBoardLayerTen />
      </MasterLayout>

      {/* Modal de Boas-Vindas (primeira vez) */}
      <WelcomeModal 
        show={showWelcomeModal} 
        onHide={handleCloseWelcome} 
      />
    </>
  );
};

export default HomePageTen;
